// Module
var code = "<was-this-useful additional-data-to-send=\"$ctrl.additionalDataToSend\" item-link=\"$ctrl.itemLink\" contact-support-url=\"$ctrl.contactSupportUrl\" reset-on-changes=\"$ctrl.resetOnChanges\" sitecore-id=\"$ctrl.sitecoreId\"/>";
// Exports
module.exports = code;